export default __webpack_public_path__ + "static/header.intercable-91e5b2570082f687802b932d334ccaea.jpg";